import {
  SOCKET_UPDATE_NOTIFIACTIONS_BADGE,
  SOCKET_CHECK_MESSAGE_TYPE,
} from "@/store/actions/sockets";

export const getDefaultState = () => ({
  showNotificationBadge: false,
});
const state = getDefaultState();

const getters = {
  getShowNotificationBadge: (state) => state.showNotificationBadge,
};

const actions = {
  [SOCKET_CHECK_MESSAGE_TYPE]: ({ commit }, message) => {
    if (message == null || typeof message === "undefined") {
      return;
    }

    if (message.type === "notification") {
      commit(SOCKET_UPDATE_NOTIFIACTIONS_BADGE, message);
      return;
    }

    if (message.type === "debug") {
      return;
    }

    console.error("Unsupported socket message type");
    return;
  },
};

const mutations = {
  [SOCKET_UPDATE_NOTIFIACTIONS_BADGE]: (state, message) => {
    const checkMessageForBadge = (message) => {
      if (message == null || typeof message === "undefined") {
        return false;
      }

      if (typeof message.badge_count === "undefined") {
        return false;
      }

      if (message.badge_count > 0) {
        return true;
      }

      if (message.badge_count === 0) {
        return false;
      }

      console.error("Unhandled notification message");
      return false;
    };
    state.showNotificationBadge = checkMessageForBadge(message);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
